import { useEffect } from "react";

type DataLayer = unknown[];
type Gtag = (...args: unknown[]) => void;

export function useGoogleAnalytics(measurementId: string): void {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    // Check if this gtag.js measurement is already loaded
    const existingScript = document.querySelector(
      `script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`,
    );

    if (existingScript) {
      return;
    }

    // Initialize dataLayer and the gtag function
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag(...args: unknown[]) {
        window.dataLayer?.push(args);
      };

    window.gtag("js", new Date());
    window.gtag("config", measurementId);

    // Create and insert the gtag.js loader script
    const script = document.createElement("script");

    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

    document.head.append(script);

    return () => {
      // Cleanup: remove the loader script on unmount
      const s = document.querySelector(
        `script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`,
      );

      s?.remove();
    };
  }, [measurementId]);
}

declare global {
  interface Window {
    dataLayer?: DataLayer;
    gtag?: Gtag;
  }
}
